import { defineMessage, defineMessages } from "react-intl";

/** Messages shared by the investigation screens (home, lists, profiles, map section). */
export const accessMessages = defineMessages({
  noPermissionTitle: {
    id: "investigation.home.noPermission.title",
    defaultMessage: "You do not have access to this screen",
  },
  noPermissionDescription: {
    id: "investigation.home.noPermission.description",
    defaultMessage: "Ask an Administrator of your operator for the Explorer read permission.",
  },
  notFoundTitle: {
    id: "investigation.home.notFound.title",
    defaultMessage: "Nothing found here",
  },
  notFoundDescription: {
    id: "investigation.home.notFound.description",
    defaultMessage:
      "It does not exist in this installation's environment, or you do not have access to it.",
  },
  loadErrorTitle: {
    id: "investigation.home.loadError.title",
    defaultMessage: "We could not load this screen",
  },
});

export const periodMessages = defineMessages({
  label: { id: "investigation.list.period.label", defaultMessage: "Period" },
  from: { id: "investigation.list.period.from", defaultMessage: "From" },
  to: { id: "investigation.list.period.to", defaultMessage: "To" },
  apply: { id: "investigation.list.period.apply", defaultMessage: "Apply period" },
  invalid: {
    id: "investigation.list.period.invalid",
    defaultMessage: "The start date must not be after the end date.",
  },
});

export const relatedMessages = defineMessages({
  statusNone: { id: "investigation.list.status.none", defaultMessage: "None" },
  statusBlocked: { id: "investigation.list.status.blocked", defaultMessage: "Blocked" },
});

export const blockedWithReasonMessage = defineMessage<{ reason: string }>(
  { id: "investigation.list.status.blockedReason", defaultMessage: "Blocked · {reason}" },
  { typed: true },
);

export const operatorOptionMessage = defineMessage<{ id: string }>(
  { id: "investigation.list.operatorOption", defaultMessage: "Operator {id}" },
  { typed: true },
);

export const timelineMessages = {
  ...defineMessages({
    approved: { id: "investigation.user.timeline.approved", defaultMessage: "Approved" },
    denied: { id: "investigation.user.timeline.denied", defaultMessage: "Denied" },
    day: { id: "investigation.user.timeline.day", defaultMessage: "Day" },
  }),
  barTitle: defineMessage<{ day: string; approved: number; denied: number }>(
    {
      id: "investigation.user.timeline.barTitle",
      defaultMessage: "{day}: {approved, number} approved, {denied, number} denied",
    },
    { typed: true },
  ),
};
